import React from "react"
import style from "./Menu.module.css"
import logo from "../../assets/images/Logo.png"
import Animate, { AnimationTypes } from "../Animate/Animate"
import { useLocation, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons"
import { PATH_MAP } from "../../configuration/PathMap"
import { ChangeLanguage } from "../ChangeLanguage/ChangeLanguage"

type MenuProps = {
  fallbackPath?: string
  showReturn?: boolean
}

const Menu: React.FC<MenuProps> = ({ fallbackPath = PATH_MAP.ROOT_PAGE, showReturn = true }) => {
  const navigate = useNavigate()

  const location = useLocation()

  const isFirstPage = location.pathname === PATH_MAP.ROOT_PAGE

  const handleGoBack = () => {
    navigate(-1)

    setTimeout(() => {
      if (location.pathname === window.location.pathname) {
        navigate(fallbackPath, { replace: true })
      }
    }, 0)
  }

  return (
    <div className={style.menu}>
      {!isFirstPage && showReturn && (
        <Animate type={AnimationTypes.slideRightIn} duration="1.2s">
          <button
            className={style.backButton}
            onClick={handleGoBack}
            type="button"
            data-interaction-description-key="interactionDescriptions:components.menu.menu.button.handleGoBack"
          >
            <FontAwesomeIcon icon={faAngleLeft} className={style.icon} />
          </button>
        </Animate>
      )}

      <div className={style.content}>
        <Animate type={AnimationTypes.slideRightIn} duration="1.3s">
          <a
            className={style.logoButton}
            href={PATH_MAP.HOME_PAGE.replace("*", "")}
            data-interaction-description-key="interactionDescriptions:components.menu.menu.link.link"
          >
            <img className={style.iconLogo} src={logo} alt="Mestre da Comanda" />
          </a>
        </Animate>

        {/*<ChangeLanguage />*/}
      </div>
    </div>
  )
}

export default Menu
